export default __webpack_public_path__ + "static/media/mines1-compressed.c327a490.jpg";